import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import LinkList from "theme/components/molecules/LinkList";
import LabelledIcon from "theme/components/molecules/LabelledIcon";
import { defineMessages, useIntl } from "react-intl";
import FormActions from "theme/components/molecules/Form/FormActions";

const messages = defineMessages({
  account: {
    id: "layouts.Header.Navigation.Menu.MenuNavigationMobile.account",
    defaultMessage: "My account",
  },
  wishlist: {
    id: "layouts.Header.Navigation.Menu.MenuNavigationMobile.wishlist",
    defaultMessage: "Wishlist",
  },
  products: {
    id: "layouts.Header.Navigation.Menu.MenuNavigationMobile.products",
    defaultMessage: "Our products",
  },
});

const categoriesToList = (categories) =>
  categories.map((category) => ({
    path: category.path,
    name: category.name,
    renderSubNav:
      category.children?.length &&
      (() => <LinkList hidden list={categoriesToList(category.children)} />),
  }));

const MenuNavigation = ({ data, wishlistFeature }) => {
  const intl = useIntl();

  return (
    <nav className="menu-nav-mobile">
      <div className="menu-nav-mobile__main-links">
        <div className="container">
          <FormActions>
            <Link to="/user">
              <LabelledIcon icon="user">
                {intl.formatMessage(messages.account)}
              </LabelledIcon>
            </Link>
            {!wishlistFeature.loading && wishlistFeature.isFeatureActive ? (
              <Link to="/user/wishlist">
                <LabelledIcon icon="heart">
                  {intl.formatMessage(messages.wishlist)}
                </LabelledIcon>
              </Link>
            ) : null}
          </FormActions>
        </div>
      </div>

      <div className="container">
        <LinkList
          title={intl.formatMessage(messages.products)}
          list={categoriesToList(data.navigationMenu)}
        />
      </div>
    </nav>
  );
};

export default MenuNavigation;
